import BundlesList from './BundlesList';

export default BundlesList;
